import { motion } from "framer-motion";
import { TESTIMONIALS } from "../data/content";

const EASE = [0.22, 1, 0.36, 1];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.header
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <p className="text-[11px] font-mono tracking-[0.25em] uppercase text-stone-500">
            05 // Voices
          </p>
          <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-normal tracking-tight text-ivory">
            Words That <span className="italic text-champagne">Outlive the Day</span>
          </h2>
        </motion.header>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={t.author}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 48 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.12, ease: EASE }}
              className={`border border-white/10 bg-surface p-8 flex flex-col ${i === 1 ? "md:mt-12" : ""}`}
            >
              <span className="font-serif text-5xl leading-none text-gold/50">“</span>
              <p className="mt-2 flex-1 font-serif italic text-lg leading-relaxed text-stone-200">
                {t.quote}
              </p>
              <footer className="mt-8 border-t border-white/10 pt-5">
                <p className="text-sm font-sans font-medium text-ivory">{t.author}</p>
                <p className="mt-1 text-[10px] font-mono tracking-[0.2em] uppercase text-stone-500">
                  {t.venue} · {t.date}
                </p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
